module.exports = require("core-js/library/fn/array/is-array");


//////////////////
// WEBPACK FOOTER
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
// module id = 385
// module chunks = 0 1 2 3 4 5 6